import { render } from "./EditTimeslotModal.vue?vue&type=template&id=22bcc268&scoped=true"
import script from "./EditTimeslotModal.vue?vue&type=script&lang=js"
export * from "./EditTimeslotModal.vue?vue&type=script&lang=js"

import "./EditTimeslotModal.vue?vue&type=style&index=0&id=22bcc268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bcc268"]])

export default __exports__